<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="classform" :rules="rules" :model="appClass">
      <el-form-item prop="appClassificationName" label="分类名称" :label-width="formLabelWidth">
        <el-input v-model="appClass.appClassificationName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
        <el-input v-model="appClass.description" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { errorHandle } from '../../../../utils/error';
export default {
  name: 'CreateOrEditAppClass',
  props: {
    parentAppClass: Object,
    appClass: {
      type: Object,
      default: () => {
        return {
          parentAppClassificationID: '',
          appClassificationName: '',
          description: '',
          marketID: ''
        };
      }
    },
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      rules: {
        appClassificationName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 2, max: 20, message: '分类名称建议2-20个字符之间', trigger: 'blur' }
        ]
      },
      app: {},
      title:
        this.appClass && this.appClass.appClassificationID
          ? '编辑分类'
          : '添加下级分类',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {
  },
  methods: {
    submit() {
      this.Loading = true;
      this.$refs.classform.validate(valid => {
        if (valid) {
          if (
            (this.appClass.appClassificationID == undefined ||
              this.appClass.appClassificationID == '') &&
            this.parentAppClass && this.parentAppClass.appClassificationID != ''
          ) {
            this.appClass.parentAppClassificationID = this.parentAppClass.appClassificationID;
          }
          this.appClass.marketID = this.marketID;
          this.$store
            .dispatch(
              this.appClass.appClassificationID
                ? 'UpDateStoreAppClassificationInfo'
                : 'AddStoreAppClassification',
              this.appClass
            )
            .then(res => {
              this.onSuccess && this.onSuccess();
              this.close();
              this.Loading = false;
            })
            .catch(res => {
              errorHandle(res)
              this.Loading = false;
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.classform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/createOrEditAppClass.vue